import React from "react";

function SvgPen2({ className, currentColor, stroke }) {
  return (
    <svg
      className={`${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4947_47797)">
        <path
          d="M18.8332 0.970002C18.1522 0.317502 17.4011 -0.0131226 16.5992 -0.0131226C15.3455 -0.0131226 14.4308 0.796878 14.1804 1.045C13.8283 1.39375 1.81419 13.4122 1.81419 13.4122C1.73545 13.4913 1.67861 13.5895 1.64921 13.6972C1.37827 14.6984 0.0210837 19.1409 0.00760714 19.1856C-0.0620608 19.4131 0.000107143 19.661 0.16792 19.8288C0.286297 19.9468 0.446654 20.0131 0.613838 20.0131C0.678525 20.0131 0.743818 20.0034 0.807568 19.9825C0.853506 19.9675 5.43913 18.4853 6.1938 18.26C6.29337 18.23 6.38412 18.1761 6.45817 18.1031C6.93505 17.6319 18.1404 6.55125 18.8841 5.78313C19.6535 4.99031 20.0357 4.16469 20.021 3.32969C20.0057 2.50531 19.606 1.71157 18.8332 0.970002ZM13.9814 3.04375C14.2998 3.12094 15.0508 3.37309 15.8177 4.14686C16.5927 4.92873 16.8024 5.82248 16.8414 6.02592C14.3839 8.47061 8.72704 14.0675 6.49704 16.2734C6.2911 15.7937 5.95829 15.2159 5.42296 14.6765C4.76923 14.0178 4.1039 13.6456 3.59077 13.4363C5.79765 11.2291 11.5611 5.46313 13.9814 3.04375ZM2.74204 14.4912C3.08548 14.5825 3.7989 14.8472 4.5261 15.5803C5.0861 16.145 5.35048 16.7678 5.46923 17.1475C4.60048 17.4268 2.69829 18.0834 1.48954 18.4731C1.84767 17.2947 2.45265 15.4593 2.74204 14.4912ZM17.977 4.88996C17.9376 4.93016 17.8981 4.97027 17.8586 5.01028C17.661 4.50151 17.3145 3.84778 16.7145 3.24278C16.1014 2.62465 15.4795 2.25996 14.9811 2.04434C15.0236 2.00215 15.0564 1.96901 15.0692 1.95653C15.1408 1.88588 15.7898 1.26559 16.5989 1.26559C17.0645 1.26559 17.5217 1.47809 17.9586 1.89684C18.4764 2.3934 18.7433 2.8834 18.752 3.35371C18.7604 3.83371 18.4998 4.35059 17.977 4.88996Z"
          fill={currentColor || "#7575A8"}
        />
      </g>
      <defs>
        <clipPath id="clip0_4947_47797">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPen2;
